<template>
    <transition name="modal-fade">
        <div class="modal modal-mask" style="display: block">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <template>
                        <div class="modal-header">
                            <h5 class="modal-title red">Session Timed Out</h5>
                            <button type="button" class="close" v-on:click="reloadPage">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="flex-r mt-3 mb-3">
                                <div class="flex-c flex-center ml-4 mr-5">
                                    <i class="fal fa-fw fa-3x fa-clock red"></i>
                                </div>
                                <div class="flex-c flex-center mt-3 mb-3">
                                    Your browser has been inactive for longer than 120 minutes and your session has expired.<br><br>You will now be redirected to the login screen.
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary btn-gradient" @click="reloadPage">Login</button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </transition>


</template>

<script>
    export default {
        props: [],

        data() {
            return {
                lang: lang,
            }
        },

        methods: {

            closeModal() {
                this.$emit('close');
            },

            reloadPage() {
                location.reload();
            },

        }
    }
</script>
